import _extends from "@babel/runtime/helpers/extends";
import { Box } from '@wix/design-system';
import { ErrorsUtils } from '@wix/package-picker-shared';
import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';
import * as Errors from '@wix/wix-ui-premium-purchase/@errors';
import React, { useEffect, useRef } from 'react';
import { useCurrentModule } from '../../components';
import { useStudioPanorama } from '../../hooks';
const extractRequestId = error => {
  var _response;
  return typeof error === 'object' && !!error ? error == null || (_response = error.response) == null ? void 0 : _response.requestId : undefined;
};
const ErrorPageWrapper = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    height: "80vh"
  }, /*#__PURE__*/React.createElement(Box, _extends({
    dataHook: "app-error-page",
    width: "100%",
    height: "100%",
    align: "center",
    verticalAlign: "middle"
  }, props), children));
};
const GeneralErrorMapper = _ref2 => {
  let {
    error: generalError,
    ...uiProps
  } = _ref2;
  const module = useCurrentModule();
  const panorama = useStudioPanorama();
  const errorType = ErrorsUtils.getErrorType(generalError);
  const reportedErrorsRef = useRef(new Set());
  const errorMessage = generalError instanceof Error ? generalError == null ? void 0 : generalError.message : undefined;
  const errorKey = `${errorType}-${errorMessage}`;
  const requestId = extractRequestId(generalError);
  useEffect(() => {
    if (!reportedErrorsRef.current.has(errorKey)) {
      reportedErrorsRef.current.add(errorKey);
      module.internals.bi.onError == null || module.internals.bi.onError({
        errorType,
        errorMessage,
        requestId
      });
      panorama.reportError(new Error(errorMessage), {
        tags: {
          errorType,
          errorMessage: errorMessage == null ? void 0 : errorMessage.replace('\n', ' '),
          requestId
        }
      });
    }
  }, [errorKey, errorType, errorMessage, requestId, module.internals.bi, panorama]);
  const Component = React.useMemo(() => {
    return () => {
      const extendedErrors = {
        ...Errors
      };
      const ErrorComponent = extendedErrors[errorType];
      return /*#__PURE__*/React.createElement(ErrorComponent, uiProps[errorType]);
    };
  }, [errorType, uiProps]);
  return /*#__PURE__*/React.createElement(Component, null);
};
export const AppErrorsMapper = _ref3 => {
  let {
    error
  } = _ref3;
  const module = useCurrentModule();
  const {
    siteId
  } = usePremiumEssentialsContext();
  const {
    t
  } = module.internals.useTranslations();
  return /*#__PURE__*/React.createElement(ErrorPageWrapper, null, /*#__PURE__*/React.createElement(GeneralErrorMapper, {
    error: error,
    TechnicalError: {
      content: {
        title: t('premium-purchase-plan.studio-package-picker.technical-error.title'),
        subtitle: t('premium-purchase-plan.studio-package-picker.technical-error.body'),
        refresh: t('premium-purchase-plan.studio-package-picker.technical-error.cta')
      }
    },
    ConnectionError: {
      content: {
        title: t('premium-purchase-plan.studio-package-picker.network-error.title'),
        subtitle: t('premium-purchase-plan.studio-package-picker.network-error.body'),
        tryAgain: t('premium-purchase-plan.studio-package-picker.network-error.cta')
      }
    },
    PermissionErrorWrapper: {
      contentKeys: {
        title: t('premium-purchase-plan.studio-package-picker.permissions-error.title'),
        subtitle: t('premium-purchase-plan.studio-package-picker.permissions-error.body'),
        subtitleNoSiteName: t('premium-purchase-plan.studio-package-picker.permissions-error.body'),
        goToDashboard: t('premium-purchase-plan.studio-package-picker.permissions-error.cta')
      },
      msid: siteId,
      t,
      onActionClick: () => {
        location.reload();
      }
    }
  }));
};
//# sourceMappingURL=AppErrorsMapper.js.map